import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { apiService } from '../../../client/common/apiCallService';
import PropTypes from 'prop-types';

const TimeRangeTabs = ({ coinName, setData, setLoading, initialFetchRef }) => {
    const [activeTab, setActiveTab] = useState('1W');

    const clientData = useSelector(state => state.juno.clientData);
    const api_url = useSelector(state => state.config.api_url);

    const tabs = ['1W', '1M', '3M', '6M', '1Y'];
    const tabToDays = {
        '1W': 7,
        '1M': 30,
        '3M': 90,
        '6M': 180,
        '1Y': 365,
    };

    const getCryptoGraphs = async range => {
        if (!coinName) {
            return;
        }
        const endpoint = `${
            window.location.hostname === 'localhost' ? api_url : ''
        }/restapi/get-crypto-price`;
        setLoading(true);
        apiService(
            endpoint,
            {
                clientEmail: clientData?.clientEmail,
                REQUEST_TYPE: 'coingecko-trend-coin',
                coinName: coinName?.toLowerCase(),
                range: range,
            },
            async data => {
                setData(data?.data?.[0]?.trend);
                setLoading(false);
            },
            error => {
                console.error(error);
                setLoading(false);
            },
        );
    };

    const handleTabClick = tab => {
        setActiveTab(tab);
        const days = tabToDays[tab] || 7;
        getCryptoGraphs(days);
    };

    useEffect(() => {
        if (!initialFetchRef || initialFetchRef.current === false) {
            if (initialFetchRef && coinName) {
                initialFetchRef.current = true;
            }
            getCryptoGraphs(tabToDays['1W']);
        }
    }, [coinName]);

    return (
        <div className="flex flex-col gap-6">
            <div className="flex items-center gap-1 p-[2px] bg-graphs-expand-border rounded-lg">
                {tabs.map(tab => (
                    <button
                        key={tab}
                        className={`flex-1 justify-center items-center gap-[10px] px-[18px] py-[6px] text-[#18181B] dark:text-[#D1D1D6] font-medium rounded-lg ${
                            activeTab === tab
                                ? 'bg-[#FFF] !text-[#18181B] rounded-lg font-semibold'
                                : ''
                        }`}
                        onClick={() => handleTabClick(tab)}>
                        {tab}
                    </button>
                ))}
            </div>
        </div>
    );
};

TimeRangeTabs.propTypes = {
    coinName: PropTypes.string.isRequired,
    setData: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
    initialFetchRef: PropTypes.object,
};

export default TimeRangeTabs;
